export const boolToStr = (value) => {
  if (value === null) {
    return 'N/A';
  } else if (value) {
    return 'Yes';
  } else {
    return 'No';
  }
};
